import { FC } from "react";
import { Link, Button, Grid, Image, Paragraph } from "capitalrx-components-2.0";

import styles from "./YouDeserveABetterRX.module.scss";
import WomanSmilingImage from "@/static/images/image-woman-card-min.png";

import CardSection from "./CardSection";

const ReadMore: FC = () => {
  return (
    <section className={styles.sectionReadMoreBg} data-testid="read_more_section">
      <div className={styles.sectionReadMore}>
        <div className={styles.sectionReadMoreTextContainer}>
          <div className={styles.sectionReadMoreText}>Read more about the Capital Rx Advantage</div>
        </div>
        <Link
          href="https://www.forbes.com/sites/alexknapp/2021/08/11/this-companyaims-to-bring-down-the-cost-of-your-medicine-with-price-transparency/?sh=31c464cf5e86"
          className={styles.sectionViewArticleLink}
        >
          <Button>View Article</Button>
        </Link>
      </div>
    </section>
  );
};

const YouDeserveABetterRX: React.FC = () => {
  return (
    <>
      <section className={styles.youDeserve} data-testid="you-deserve-section">
        <div className={styles.youDeserveWrapper}>
          <Grid container centered justifyContent="center" className={styles.youDeserveGridContainer}>
            <Grid item colLg={7} colSm={6} className={styles.youDeserveTextWrapper}>
              <Paragraph className={styles.youDeserveTextTitle}>You deserve a better Rx</Paragraph>
              <Paragraph className={styles.paragraphOne}>
                Traditional discount card programs charge high, hidden fees and artificially inflate the cost of your drugs, without any
                accountability.
              </Paragraph>
              <Paragraph className={styles.paragraphTwo}>
                <span>We&apos;re here to change that.</span> Capital Rx is proud to bring you a discount card with lower fees and higher
                potential savings.
              </Paragraph>
            </Grid>
            <Grid item colLg={5} className={styles.womanSmiling}>
              <Image src={WomanSmilingImage} alt="woman smiling" className={styles.imageWoman} ariaHidden="true" />
            </Grid>
          </Grid>
        </div>

        <CardSection />
      </section>
      <ReadMore />
    </>
  );
};

export default YouDeserveABetterRX;
